<template>
  <div id="app">
    <Main/>
    
  </div>
</template>

<script>
import Main from './components/Main.vue'
import Menu from './components/Menu.vue'
import carousel from 'vue-owl-carousel'
export default {
  name: 'app',
  components: {
    Main,
    Menu,
    carousel
  }
}
</script>

<style lang="scss">

@font-face {
    font-family: Almira;
    src: url("./assets/fonts/AlmiraRegular.woff") format("woff"),;
}
@font-face {
    font-family: Almira;
    font-weight:bold;
    src: url("./assets/fonts/Almira bold.woff") format("woff"),;
}
@font-face {
    font-family: Almira;
    src: url("./assets/fonts/Almira italic.woff") format("woff"),;
    font-style: italic;
}

@font-face {
    font-family: Almira;
    font-weight:bold;
    src: url("./assets/fonts/Almira bold italic.woff") format("woff"),;
    font-style: italic;
}
@font-face {
    font-family: Almira;
    font-weight:100;
    src: url("./assets/fonts/Almira Light italic.woff") format("woff"),;
    font-style: italic;
}

@font-face {
    font-family: Almira;
    font-weight:100;
    src: url("./assets/fonts/Almira Light.woff") format("woff"),;
}

*
{

  margin:0 !important;
  outline:0;
  box-sizing: border-box;
 
  
}
body
{
  
  margin:0;
  padding:0;
  overflow:hidden;
  background:#000;
  
}
#app {
  position:absolute;
  height:1080px;
  width:1920px;
  left:50%;
  top:50%;
  
}

</style>
